import { remCss } from 'src/helpers';
import React from 'react';

const NotificationIcon = ({ width = 18.824, height = 20 }) => (
  <svg
    id='notification'
    xmlns='http://www.w3.org/2000/svg'
    width={remCss(width)}
    height={remCss(height)}
    viewBox='0 0 18.824 20'
  >
    <path
      id='Path_10677'
      data-name='Path 10677'
      d='M19.294,14.25h1.765a1.878,1.878,0,0,1,0,3.75H5.765a1.878,1.878,0,0,1,0-3.75H7.529l.657-6.281A5.385,5.385,0,0,1,13.412,3a5.385,5.385,0,0,1,5.226,4.969Z'
      transform='translate(-4 -3)'
      fill='#19175d'
      fillRule='evenodd'
    />
    <rect
      id='Rectangle_1178'
      data-name='Rectangle 1178'
      width='4'
      height='4'
      rx='2'
      transform='translate(7.412 16)'
      fill='#19175d'
      opacity='0.3'
    />
  </svg>
);

export default NotificationIcon;
